import { MailTemplateOrDraftLoaded } from 'src/models/mail';

import { Callback } from 'src/util/query/models/Callback';

import { SetMailTemplateOrDraftPayload } from '../interfaces';

export class GetTheMailTemplateOrDraftForTheAuthenticatedUserQueryCallback extends Callback<MailTemplateOrDraftLoaded> {
	public constructor(
		private readonly aggregateId: string,
		private readonly setMailTemplateOrDraft: (payload: SetMailTemplateOrDraftPayload) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: MailTemplateOrDraftLoaded): void => {
		this.setMailTemplateOrDraft({
			aggregateId: this.aggregateId,
			mailTemplateOrDraftLoaded: successResponse,
		});
	};
}
